<template>
    <div id="full-loading" :theme="theme">
        <div class="overlay-content">
            <div class="loading-content">
                <div class="lds-ellipsis">
                    <div class="green-light"></div>
                    <div class="purple-light"></div>
                    <div class="blue-light"></div>
                    <div class="pink-light"></div>
                </div>
                <span>{{message}}</span>
            </div>
        </div>
    </div>
</template>
<style>
    #full-loading {
        /* Height & width depends on how you want to reveal the overlay (see JS below) */
        height: 100%;
        width: 100%;
        z-index: 99999; /* Sit on top */
        top: 0;
        overflow-x: hidden; /* Disable horizontal scroll */
        transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
    }

    div[theme=dark]{
      position: fixed; /* Stay in place */
      background-color: rgb(0,0,0); /* Black fallback color */
      background-color: rgba(0,0,0, 0.85); /* Black w/opacity */
    }
    .loading-content{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    div[theme=dark] .loading-content{
        color: #FFF;
    }
    #full-loading .overlay-content {
        display: table;
        position: relative;
        top: 40%; /* 25% from the top */
        text-align: center; /* Centered text/links */
        margin: 0 auto !important;
    }
    .lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
<script>
    import {Circle10} from 'vue-loading-spinner';
    export default {
        components: {
            Circle10
        },
         props: {
            theme: {
                type: String,
                default: 'dark'
            },
            message: {
                type: String,
                default: 'Obtendo informações ...'
            }
        },
        data: () => ({})
    }
</script>



// WEBPACK FOOTER //
// src/components/common/FullLoading.vue